import { ApiRoute } from 'api-base-refrence';
import { ApiApiRoute } from 'app/api-route/api/api.api';
export class SystemConfigApiRoute extends ApiRoute {
  static apiName = '';
  static parent = ApiApiRoute;
  static urlPattern() {
    return `/system-config`;
  }
}
